import type { AdminDashboardSection } from "../models/admin-dashboard.models";
import { ADMIN_PATHS } from "../models/admin.models";

export const ADMIN_DASHBOARD_JOB_TREND_DAYS = 14;

// Keep the landing page focused on queues and coverage; detailed tables stay in their existing sections.
export const ADMIN_DASHBOARD_SECTIONS: readonly AdminDashboardSection[] = [
  {
    id: "cronJobs",
    title: "Scheduled jobs",
    path: ADMIN_PATHS.monitoringCronJobs,
    scope: "monitoring",
    metricKeys: [],
  },
  {
    id: "documents",
    title: "Documents",
    path: ADMIN_PATHS.monitoringDocuments,
    scope: "monitoring",
    metricKeys: ["activeDocuments", "expiredDocuments"],
    breakdownKey: "alerts",
  },
  {
    id: "techForms",
    title: "Technical forms",
    path: ADMIN_PATHS.monitoringTechForms,
    scope: "monitoring",
    metricKeys: ["pending", "stalePending"],
    breakdownKey: "statuses",
  },
  {
    id: "balticQuestionnaires",
    title: "Baltic questionnaires",
    path: ADMIN_PATHS.monitoringBalticQuestionnaires,
    scope: "monitoring",
    metricKeys: ["pending", "stalePending"],
    breakdownKey: "statuses",
  },
  {
    id: "voyagePnl",
    title: "Voyage PnL",
    path: ADMIN_PATHS.monitoringVoyagePnl,
    scope: "monitoring",
    metricKeys: ["pendingApprovals", "highVariance"],
    breakdownKey: "approvalStatus",
  },
  {
    id: "vessels",
    title: "Fleet & onboarding",
    path: ADMIN_PATHS.monitoringVessels,
    scope: "monitoring",
    metricKeys: ["activeFleet", "missingEmails"],
    breakdownKey: "oktaActivation",
  },
  {
    id: "voyages",
    title: "Voyages",
    path: ADMIN_PATHS.monitoringVoyages,
    scope: "monitoring",
    metricKeys: ["activeVoyages", "assessmentRequests"],
    breakdownKey: "checklistCompletion",
  },
  {
    id: "notifications",
    title: "Notifications",
    path: ADMIN_PATHS.monitoringNotifications,
    scope: "monitoring",
    metricKeys: ["created24h", "unread"],
    breakdownKey: "readState",
  },
  { id: "crewReport", title: "Crew reports", path: ADMIN_PATHS.crewReport, scope: "app", metricKeys: [] },
  { id: "uwhc", title: "Hull cleaning providers", path: ADMIN_PATHS.uwhc, scope: "app", metricKeys: [] },
  { id: "keysSecrets", title: "Keys & secrets", path: ADMIN_PATHS.keysSecrets, scope: "app", metricKeys: [] },
];

export const ADMIN_DASHBOARD_MANAGEMENT_LINKS = [
  { id: "debug", label: "Debug tools" },
  { id: "paintSchemes", label: "Paint schemes" },
  { id: "voyagePnl", label: "PnL approvers" },
  { id: "certificatesSettings", label: "Certificate settings" },
  { id: "kpis", label: "Certificate KPIs" },
  { id: "bqTqAdmin", label: "BQ/TQ administration" },
  { id: "accessControl", label: "Access control" },
] as const;

export const ADMIN_DASHBOARD_TONE_CLASSES = {
  success: "text-green dark:text-teal-300",
  warning: "text-[#946200] dark:text-amber-300",
  danger: "text-[#BF0002] dark:text-red-300",
  neutral: "",
};
